/** @file 抢答 语言配置 */
const zhCN = {
  rushAnswer: {
    rushAnswer: '抢答',
    countdown: '抢答倒计时',
    remainingNumebr: '剩余抢答名额',
    unit: '人',
    success: '参与抢答成功',
    waitForInvitation: '请等待老师邀请回答',
    fail: '抢答已结束',
    answer: '立即抢答',
    ok: '我知道了',
  }
};

const en = {
  rushAnswer: {
    rushAnswer: 'Rush answer',
    countdown: 'Time remaining for answer',
    remainingNumebr: 'Remaining spots for answering',
    unit: 'people',
    success: 'Successfully participated in the quiz',
    waitForInvitation: 'Please wait for the teacher\'s invitation to answer',
    fail: 'The quiz has ended',
    answer: 'Answer quickly',
    ok: 'OK',
  }
};

export default {
  zh_CN: zhCN,
  en,
};
